import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Button, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import { useMapWorkAreasFlag } from 'modules/locations/hooks/useMapWorkAreasFlag'
import { WorkSpace } from 'modules/space_control/hooks/useWorkSpace'

import DeleteModal from './DeleteModal'

interface PropsWorkSpace {
  locationId: number
  workAreaId: number
  workSpace: WorkSpace
}

const Options = ({ locationId, workAreaId, workSpace }: PropsWorkSpace) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const hasMapWorkAreasFlag = useMapWorkAreasFlag()
  const [deleteModalOpen, toggleDeleteModal] = useToggle(false)

  const editWorkSpace = () => {
    track(trackingEvents.spaceControl.editSpace, {})

    const navigationParams = {
      id: locationId,
      workAreaId: workAreaId,
      workSpaceId: workSpace.id ? workSpace.id.toString() : '',
    }

    if (hasMapWorkAreasFlag) {
      navigate(
        navigation.settings.locations.locationsId.workAreas.workSpaces.editWorkSpace.fullPath(
          navigationParams
        )
      )
    } else {
      navigate(
        navigation.settings.locations.locationsId.workAreas.editWorkSpace.fullPath(navigationParams)
      )
    }
  }

  const canEditSpace = users.current.policy.can('spaceControl.workSpaceUpdate')
  const canDeleteSpace = users.current.policy.can('spaceControl.workSpaceDelete')

  return (
    <Box onClick={(e) => e.stopPropagation()}>
      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Button.Decorative type="secondary" iconName="ellipsis" />
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="end">
          {canEditSpace && (
            <PopoverMenu.TouchableOption
              onClick={editWorkSpace}
              title={i18n.t('settings.locations.location.work_spaces.edit.title')}
            />
          )}
          {canDeleteSpace && (
            <PopoverMenu.TouchableOption
              onClick={toggleDeleteModal(true)}
              title={i18n.t('settings.locations.location.work_spaces.delete')}
              danger
            />
          )}
        </PopoverMenu.Content>
      </PopoverMenu>
      {deleteModalOpen && (
        <DeleteModal toggleModal={toggleDeleteModal(false)} workSpace={workSpace} />
      )}
    </Box>
  )
}

export default observer(Options)
